import { useSelector } from "react-redux";
import { RootState } from "../state/reducers";

export const useAuth = () => {
    const { user_info } = useSelector((x:RootState)=> x.auth);
    
    return {
        user_info
    };
}
